import { createContext, useContext } from 'react';

import type { Theme } from './theme';

// The active colour theme + a setter, provided once at the top of the app (`_app.tsx`) and
// consumed by the Settings dark-mode toggle. The setter both flips the live theme (stamps
// `data-theme` on `<html>`, so every `--ds-*` token re-resolves immediately) AND persists the
// choice, so it sticks across reloads.
//
// Kept a separate tiny context rather than lifting state through props, for the same reason
// `LocaleContext` is: the toggle lives many levels down, on a different page than the state.
export type ThemeContextValue = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const ThemeContext = createContext<ThemeContextValue>({
  theme: 'light',
  setTheme: () => {},
});

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
